import z from 'zod';

import { WorkoutPlanId } from '../../../BrandedIds';
import { zodBrandedUuid } from '../../../utils/Zod';
import { BaseLoanEvent } from '../../BaseLoanEvent';

export const ExtendForbearanceWorkoutPlanEvent = BaseLoanEvent.extend({
  type: z.literal('extendForbearanceWorkoutPlan'),
  workoutPlanId: zodBrandedUuid<WorkoutPlanId>(),
  extensionTermMonths: z.number().positive(),
});
export type ExtendForbearanceWorkoutPlanEvent = z.infer<typeof ExtendForbearanceWorkoutPlanEvent>;
